export const UPDATE_DEAL_PROGRESS_MILESTONES = 'UPDATE_DEAL_PROGRESS_MILESTONES';
